import React, { useState, useEffect, useContext } from 'react';


import SimpleTable from '../../components/tables/simpleTable';
import { typeFormatter, paymentTypeFormatter } from '../../components/formatters/defFormatter';
import TrashModal from '../../components/modals/trashModal';
import RecoverModal from '../../components/modals/recoverModal';
import AddWITHPRINTModal from '../../components/modals/addWithPrintModal';
import EditModal from '../../components/modals/editModal';
import DeleteModal from '../../components/modals/deleteModal';
import CartModal from '../../components/modals/cartModal';
import SearchFilter from '../../components/filters/search';
import CustomButton from '../../components/buttons/customButton';
import IsActiveFilter from '../../components/filters/isActive';
import AddButton from '../../components/buttons/addButton';
import DataFilter from '../../components/filters/dataFilter';
import DatePicker from '../../components/filters/datePicker';
import { dateTableFormatter } from '../../dynamic/dateFormatter';
import { FaPlus } from "react-icons/fa";
import { FcKindle } from "react-icons/fc";
import Loader from '../../components/loader/loader';
import { numberFormatter, totalFormatter } from '../../components/formatters/numberFormatter';
import { dateFormatter } from '../../dynamic/dateFormatter';
import { clientOrderColumnDefs } from '../../components/tables/columnDefs';
import toast from 'react-hot-toast';

import { Space, Input, Tag, Button, Tabs } from 'antd';


import Select from 'react-select';
import { Col, Form, Row, DropdownButton, Dropdown } from 'react-bootstrap';


import { FiEdit } from "react-icons/fi";
import { FcUndo, FcViewDetails, FcFlowChart, FcRules } from "react-icons/fc";
import { BiSolidTrash, BiBarcodeReader } from "react-icons/bi";
import { IoBarcodeOutline } from "react-icons/io5";
import { FcPlus } from "react-icons/fc";
import { HiMinusCircle } from "react-icons/hi";

import { DataContext } from '../../init/getData';




function MembershipTransaction(props) {

  let { } = props;


  const { userData, api, refClass, classData, refAccountMember, accountMemberData } = useContext(DataContext);
  const userRole = userData.role;
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState([]);
  const createdBy = parseInt(userData.id);
  const [idRow, setIdRow] = useState([]);
  const [refreshTable, setRefreshTable] = useState(true);
  const [columnDefs, setColumnDefs] = useState([]);
  const today = new Date().toISOString().split('T')[0];
  const defaultExpiryDate = new Date();
  defaultExpiryDate.setMonth(defaultExpiryDate.getMonth() + 1);
  const [filter, setFilter] = useState({ search: '', isActive: 'true', type: "membership", fromDate: today, toDate: today });

  const [showAddModal, setShowAddModal] = useState(false);
  const [showTrashModal, setShowTrashModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showRecoverModal, setShowRecoverModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showCartModal, setShowCartModal] = useState(false);
  const [createdUser, setCreatedUser] = useState(null);
  const table = 'transaction';
  const title = 'Membership Transaction';


  const [transaction, setTransaction] = useState({});




  useEffect(() => {
    const fetchData = async () => {
      try {
        await refClass();
        await refAccountMember();
        setIsLoading(false);
      } catch (error) {
        console.error('Error refreshing data Contact Support');
      }
    };
    fetchData();
  }, []);



  const classOptions = classData.map(item => ({
    value: item.id,
    label: `${item.name} (${item.trainer?.name || 'No Trainer'})`,
    price: item.price,
    trainerId: item.trainerId,
  }));


  const memberOptions = accountMemberData.map(item => ({
    value: item.id,
    label: `${item.name} [${item.barcode}]`,
    price: item.price,
  }));


  // idRow Change
  useEffect(() => {

    setTransaction(
      {
        createdBy: createdBy,
        classId: idRow?.classId || null,  
        memberId: idRow?.memberId || null,
        classPrice: idRow?.classPrice,
        trainerId: idRow?.trainerId,
        isOut: false,
        type: 'membership',
        usd: idRow?.usd,
        discount: idRow?.discount || 0,
        classPrice: idRow?.classPrice || 0,
        registrationDate: idRow?.registrationDate || today,
        expiryDate: idRow?.expiryDate || defaultExpiryDate.toISOString().split('T')[0],
      }
    );
    
    
  }, [idRow]);

  

  



  const addModal = (type) => {
    setIdRow({});
    resetForm();
    setShowAddModal(!showAddModal);
  }



  const resetForm = () => {
    setTransaction(
      {
        createdBy: createdBy,
        classId: idRow?.classId || null,
        memberId: idRow?.memberId || null,
        classPrice: idRow?.classPrice,
        trainerId: idRow?.trainerId,
        isOut: false,
        type: 'membership',
        usd: idRow?.usd,
        discount: idRow?.discount || 0,
        classPrice: idRow?.classPrice || 0,
        registrationDate: idRow?.registrationDate || today,
        expiryDate: idRow?.expiryDate || defaultExpiryDate.toISOString().split('T')[0],
      }
    )
  };



  // Generic handler for input changes
  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (value === 'true' || value === 'false') {
      value = JSON.parse(value);
    }

    if (name === 'registrationDate') {
      // Ensure value is in YYYY-MM-DD format
      const [year, month, day] = value.split('-').map(Number);

      // Correct month and day if they are invalid
      const correctedMonth = month > 0 && month <= 12 ? month : 1;
      const correctedDay = day > 0 && day <= 31 ? day : 1; // Simple check; consider months with different days

      // Construct corrected date string
      const correctedDate = `${year}-${String(correctedMonth).padStart(2, '0')}-${String(correctedDay).padStart(2, '0')}`;

      const registrationDate = new Date(correctedDate);
      if (!isNaN(registrationDate)) {
        let expiryDate = new Date(registrationDate);
        expiryDate.setMonth(expiryDate.getMonth() + 1);

        setTransaction((prevTransaction) => ({
          ...prevTransaction,
          [name]: correctedDate,
          expiryDate: expiryDate.toISOString().split('T')[0],
        }));
      } else {
        console.error("Invalid date");
      }
    } else {
      setTransaction((prevTransaction) => {
        const updatedTransaction = {
          ...prevTransaction,
          [name]: value,
        };

        // Calculate usd with percentage discount
        const usd = updatedTransaction.classPrice - updatedTransaction.discount;

        return {
          ...updatedTransaction,
          usd: usd, // Format to 3 decimal places
        };
      });
    }
  };



  const handleSelectChange = (selectedOption, name) => {

    if (name == 'classId') {
      setTransaction((prevtransaction) => ({
        ...prevtransaction,
        [name]: selectedOption.value,
        classPrice: selectedOption.price,
        discount: 0,
        usd: selectedOption.price,
        trainerId: selectedOption.trainerId,
      }));
    }
    else if (name == 'memberId') {
      setTransaction((prevtransaction) => ({
        ...prevtransaction,
        [name]: selectedOption.value,
      }));
    }
  };


  const refreshTableFunction = () => {
    setRefreshTable(!refreshTable)
  }

  const recoverModal = (e) => {
    if (!showRecoverModal) {
      setIdRow(e);
    }
    setShowRecoverModal(!showRecoverModal);
  }

  const trashModal = (e) => {
    if (!showTrashModal) {
      setIdRow(e);
    }
    setShowTrashModal(!showTrashModal);
  }

  const deleteModal = (e) => {
    if (!showDeleteModal) {
      setIdRow(e);
    }
    setShowDeleteModal(!showDeleteModal);
  }

  const cartModal = (e) => {
    if (!showCartModal) {
      setIdRow(e);
    }
    setShowCartModal(!showCartModal);
  }

  const editModal = (e) => {
    if (!showEditModal) {
      setIdRow(e);
    }
    setShowEditModal(!showEditModal);
  }

  //Excel Data
  const getExcelData = (data) => {

    const transformedData = [];
    data.forEach(item => {

      const newItem = {
        id: item.id,
        class: item.class?.name,
        classPrice: item.classPrice,
        trainerId: item.trainerId,
        account: item.account?.name,
        usd: item.classPrice,
      };

      transformedData.push(newItem);
    });

    return transformedData;
  };

  useEffect(() => {

    let updatedColumnDefs = [
      { title: 'createdAt', dataIndex: 'createdAt', render: dateTableFormatter },
      {
        title: 'Barcode',
        dataIndex: 'member',
        render: (member) => (
          member ? (
            <div>
              <span>{member.barcode}</span>
            </div>
          ) : null
        )
      },
      {
        title: 'Member',
        dataIndex: 'member',
        render: (member) => (
          member ? (
            <div>
              <span>{member.name}</span>
            </div>
          ) : null
        )
      },

 

      { title: 'class', dataIndex: 'class', render: (clas) => (clas?.name) },
      { title: 'trainer', dataIndex: 'trainer', render: (trainer) => (trainer?.name) },
      { title: 'Class Price', dataIndex: 'classPrice', width: '8%' },
      { title: 'Discount', dataIndex: 'discount', width: '8%' },
      { title: 'Net Price', dataIndex: 'usd', width: '8%' },
      { title: 'RegistrationDate', dataIndex: 'registrationDate' },
      { title: 'ExpiryDate', dataIndex: 'expiryDate' },
    ];


    if (filter.isActive === 'true') {
      updatedColumnDefs.push(
        {
          title: 'View',
          width: '5%',
          render: (_, record) => (
            <FcKindle size={18} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => cartModal(record)} />
          ),
        },
        {
          title: 'Edt',
          width: '5%',
          render: (_, record) => (
            <FiEdit size={16} style={{ cursor: 'pointer', color: '#2E70A5' }} onClick={() => editModal(record)} />
          ),
        },
        {
          title: 'Del',
          width: '5%',
          render: (_, record) => (
            <BiSolidTrash size={18} style={{ cursor: 'pointer', color: '#e6434f' }} onClick={() => deleteModal(record)} />
          ),
        }
      );
    } else {
      updatedColumnDefs.push({
        title: 'Rec',
        width: '5%',
        render: (_, record) => (
          <FcUndo size={20} style={{ cursor: 'pointer' }} onClick={() => recoverModal(record)} />
        ),
      });
    }


    setColumnDefs(updatedColumnDefs);

  }, [filter.isActive]);



  const formView = (
    <div style={{ userSelect: 'none' }}>
      <Row className="mb-3" style={{ marginTop: '2%' }}>
        {/* Member  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Member<span style={{ color: 'red' }}> *</span></Form.Label>
          <Select
            style={{ width: '100px' }}
            options={memberOptions}
            isSearchable={true}
            placeholder="Select"
            value={memberOptions?.find(option => option.value === transaction.memberId) || []}
            onChange={(e) => handleSelectChange(e, 'memberId')}
            required
          />
        </Form.Group>
        {/* Class  */}
        <Form.Group as={Col}>
          <Form.Label className='formLabel'>Class<span style={{ color: 'red' }}> *</span></Form.Label>
          <Select
            style={{ width: '100px' }}
            options={classOptions}
            isSearchable={true}
            placeholder="Select"
            value={classOptions?.find(option => option.value === transaction.classId) || []}
            onChange={e => handleSelectChange(e, 'classId')}
            required
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '2%' }}>
        <Form.Group as={Col}>
          <Form.Label>Price:</Form.Label>
          <input type="text" name="classPrice" id="classPrice" className="form-control"
            value={transaction.classPrice} disabled />
        </Form.Group>

        <Form.Group as={Col}>
          <Form.Label>Discount:</Form.Label>
          <input type="text" name="discount" id="discount" className="form-control"
            value={transaction.discount}
            onChange={handleInputChange}></input>
        </Form.Group>


      </Row>

      <Row className="mb-3" style={{ marginTop: '2%' }}>

        <Form.Group as={Col}>
          <Form.Label>Net Price:</Form.Label>
          <input type="text" name="usd" id="usd" className="form-control"
            value={transaction.usd}
            disabled
          />
        </Form.Group>


        <Form.Group as={Col}>
          <Form.Label>Payment:</Form.Label>
          <select className="form-control" id='isCredit' name='isCredit'
            value={transaction.isCredit}
            onChange={handleInputChange}
            required
          >
            <option value='false'>Cash</option>
            <option value='true'>Credit</option>
          </select>
        </Form.Group>
      </Row>

      {/* registrationDate */}
      <Row className="mb-3" style={{ marginTop: '2%' }}>
        <Form.Group as={Col} >
          <Form.Label className='formLabel'>Registration Date<span style={{ color: 'red' }}> *</span></Form.Label>
          <Form.Control
            type="date"
            name="registrationDate"
            value={transaction.registrationDate}
            onChange={handleInputChange}
          />
        </Form.Group>

        {/* expiryDate */}
        <Form.Group as={Col} >
          <Form.Label className='formLabel'>Expiry Date<span style={{ color: 'red' }}>*</span></Form.Label>
          <Form.Control
            type="date"
            name="expiryDate"
            value={transaction.expiryDate}
            onChange={handleInputChange}
          />
        </Form.Group>
      </Row>

      <Row className="mb-3" style={{ marginTop: '2%' }}>
        <Form.Group as={Col}>
          <Form.Label>Details</Form.Label>
          <textarea className="form-control" name="details" id="details"></textarea>
        </Form.Group>
      </Row>
    </div>
  );





  const modalFooter = (
    <div>
    </div>
  );

  const tableFooter = (

    <div style={{ display: 'flex', justifyContent: 'space-between', position: 'absolute', left: '50%', transform: 'translateX(-50%)' }}>
      <div>

        <>
          <span className='table-footer footer-one'>Count: {numberFormatter(data?.summary?.membershipCount, 2)}</span>
          <span className='table-footer footer-yellow'>Credit: {numberFormatter(data?.summary?.totalCredit, 2)}</span>
          <span className='table-footer footer-green'>Balance: {numberFormatter(data?.summary?.totalMemberships - data?.summary?.totalCredit, 2)}</span>
        </>


      </div>
    </div>

  );




  return (
    <div className='card'>

      {isLoading &&
        <Loader />
      }


      {!isLoading &&
        <>
          <div>

            <SearchFilter setFilter={setFilter} />
            <DatePicker setFilter={setFilter} filter={filter} />
            <AddButton addModal={addModal} />

          </div>



          <SimpleTable
            filter={filter}
            showAddModal={showAddModal}
            addModal={addModal}
            table={table}
            title={title}
            columnDefs={columnDefs}
            idRow={idRow}
            setIdRow={setIdRow}
            refreshTable={refreshTable}
            data={data}
            setData={setData}
            tableFooter={tableFooter}
            api={api}
            getExcelData={getExcelData}
          />

          <TrashModal
            showModal={showTrashModal}
            toggleModal={trashModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow.id }}
          />

          <RecoverModal
            showModal={showRecoverModal}
            toggleModal={recoverModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
          />

          <AddWITHPRINTModal
            showModal={showAddModal}
            toggleModal={addModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'lg'}
            resetForm={resetForm}
            footer={modalFooter}
            api={api}
            data={{ transaction }}
          />

          <EditModal
            showModal={showEditModal}
            toggleModal={editModal}
            formView={formView}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            size={'lg'}
            footer={modalFooter}
            api={api}
            data={{ id: idRow?.id, transaction }}
          />

          <DeleteModal
            showModal={showDeleteModal}
            toggleModal={deleteModal}
            idRow={idRow}
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            data={{ id: idRow?.id, transaction }}
          />

          <CartModal
            showModal={showCartModal}
            toggleModal={cartModal}
            idRow={idRow}  
            table={table}
            title={title}
            refreshTable={refreshTableFunction}
            api={api}
            createdBy={idRow?.created?.name} 
          />


 
        </>
      }

    </div>
  )
}

export default MembershipTransaction;
